import React from "react";
import { NextPage } from "next";

import CreditCheckSelf from "scenes/CreditCheck";

const Index: NextPage = () => <CreditCheckSelf />;

export default Index;
